import { ReactNode, useEffect, useMemo, useState } from "react";
import { OptionMenuContainer } from "src/components/ui/OptionMenu/OptionMenu"; 
import { EditVisitOption } from "./EditVisitOption";
import { ConfirmedDeal } from "../../../../../types/empresa";
import { ModalContainer } from "../../../../../components/ui/ModalContainer";
import { ChangeDealStageFormContainer } from "../../../ChangeDealStage/components";

interface Props {
    deal: ConfirmedDeal;
}

export function VisitOptionMenu({ deal }: Props) {
    const [currentOption, setCurrentOption] = useState<ReactNode | null>(null);
    const [showModal, setShowModal] = useState(false);

    const visitaOptions = useMemo<ReactNode[]>(() => [
        <EditVisitOption 
            setShowEditModal={setShowModal}
            setCurrentOption={setCurrentOption}
            deal={deal}/>,
        // TODO: this option will be enable soon the feature is completed
        // <CancelVisitOption 
        //     setShowModal={setShowModal}
        //     setCurrentOption={setCurrentOption}
        //     deal={deal}/>,
    ], []);

    useEffect(() => {
        if(currentOption)
            setShowModal(true);
        else
            setShowModal(false);
    }, [currentOption]);

    return (
        <>
            <OptionMenuContainer options={visitaOptions}/>

            {showModal && currentOption && (
                <ModalContainer>
                    <ChangeDealStageFormContainer
                        largeWidht
                        setShowModal={setShowModal}>
                        {currentOption}
                    </ChangeDealStageFormContainer>
                </ModalContainer>
            )}
        </>
    );
}
